// extracted by mini-css-extract-plugin
module.exports = {"container":"ReferencesInfo_container__A9kJO","loader":"ReferencesInfo_loader__Ds1Ta"};